import { useEffect, useRef } from "react";

import CompaniesSearch from "@pages/Companies/components/CompaniesSearch";
import EmbeddingSearch from "@pages/Companies/components/EmbeddingSearch";
import EmbeddingSearchLoading from "@pages/Companies/components/EmbeddingSearchLoading";

import { useCompanySearch } from "@queries/ipSearch.query";

import { useCompanyStore } from "@store/companyStore";
import { useTableStore } from "@store/filters/filters.store";
import useSmartSearchStore from "@store/smartSearch";
import { UserActions } from "@store/userStore";

const Companies = () => {
  // TODO: migrate ui control logic to zustand hook so we can set open/close state from technologies and then load this page. That way we can avoid conditional logic on render
  const { isSmartSearchEnabled, isSmartSearchFromTechnologyOverview, setIsSmartSearchEnabled } = useSmartSearchStore();

  const { setTablePagination, setTableSort } = useTableStore("company");

  const { actions: CompanyActions } = useCompanyStore();

  const { mutateAsync: fetchCompanySearch, status: loadingNewSearchStatus } = useCompanySearch();

  const isInitialLoad = useRef(true);

  // TODO: Move this into <EmbeddingSearch /> and <CompaniesSearch /> components to avoid conditional logic here?
  useEffect(() => {
    if (isInitialLoad) {
      if (isSmartSearchEnabled) {
        setTableSort([{ field: "similarityScore", sort: "desc" }]);
      } else {
        setTableSort([{ field: "numEmployees", sort: "desc" }]);
      }
      setTablePagination({
        page: 0,
        pageSize: 50,
      });

      localStorage.setItem("isSmartSearchEnabled", isSmartSearchEnabled.toString());
    }
    isInitialLoad.current = false;
    if (isSmartSearchFromTechnologyOverview) {
      setIsSmartSearchEnabled(false);
      UserActions.setCurrentSearch("new");
    }
  }, [isSmartSearchEnabled, isSmartSearchFromTechnologyOverview]);

  useEffect(() => {
    return () => {
      CompanyActions.setCompanySelection([]);
    };
  }, [CompanyActions]);

  // If the search is still loading, return the EmbeddingSearchLoading component
  if (loadingNewSearchStatus === "pending") {
    return <EmbeddingSearchLoading />;
  }

  // If smart search is enabled, return the EmbeddingSearch component
  if (isSmartSearchEnabled) {
    return (
      <EmbeddingSearch
        fetchCompanySearch={fetchCompanySearch}
        shouldTriggerModal={isSmartSearchFromTechnologyOverview}
      />
    );
  }

  // If smart search is disabled, return the CompaniesSearch component
  return (
    <CompaniesSearch fetchCompanySearch={fetchCompanySearch} shouldTriggerModal={isSmartSearchFromTechnologyOverview} />
  );
};

export default Companies;
